import React from "react";
import { Activity, ArrowUpRight, LockKeyhole, Users } from "lucide-react";

type ProtectionControl = {
  number: string;
  title: string;
  text: string;
  icon: React.ComponentType<{ className?: string }>;
};

const PROTECTION_CONTROLS: ProtectionControl[] = [
  {
    number: "01",
    title: "Zero data broker sales",
    text: "Personal birth information and injected entity milestones are not packaged or sold.",
    icon: LockKeyhole,
  },
  {
    number: "02",
    title: "Encrypted personas",
    text: "Profiles remain strictly scoped to your private account and its controls.",
    icon: Users,
  },
  {
    number: "03",
    title: "Ephemeral sessions",
    text: "Analytical queries and live readings run on isolated sessions with clear boundaries.",
    icon: Activity,
  },
];

export const DataProtectionSection: React.FC = () => (
  <section id="data-protection" className="landing-protection-section landing-reveal-section">
    <div className="landing-protection__inner">
      <div className="landing-protection__intro">
        <span className="landing-section-kicker">[ Data Protection ]</span>
        <h2>Your inner circle stays yours</h2>
        <p>
          When you map relationships, startup launch dates, and sensitive life milestones, confidentiality is not a feature.
          It is the boundary the system is built around.
        </p>
        <div className="landing-protection__status">
          <span>Privacy boundary</span>
          <strong>Account-scoped by default</strong>
          <small>03 safeguards active</small>
        </div>
      </div>

      <div className="landing-protection__panel">
        <div className="landing-protection__panel-header">
          <div>
            <span className="landing-section-kicker">Protection model</span>
            <h3>Private context, clear boundaries</h3>
          </div>
          <span className="landing-protection__panel-count">03 / 03</span>
        </div>
        <div className="landing-protection__controls">
          {PROTECTION_CONTROLS.map(({ number, title, text, icon: Icon }) => (
            <article key={title}>
              <div className="landing-protection__control-index">
                <span>{number}</span>
                <Icon aria-hidden="true" />
              </div>
              <div>
                <h4>{title}</h4>
                <p>{text}</p>
              </div>
              <ArrowUpRight aria-hidden="true" />
            </article>
          ))}
        </div>
        <div className="landing-protection__panel-footer">
          <span>Private by default</span>
          <i aria-hidden="true" />
          <span>Explicit sharing</span>
          <i aria-hidden="true" />
          <span>Clear boundaries</span>
        </div>
      </div>
    </div>
  </section>
);
